var _clipPath, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFdImgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 411 589",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.79,160.47l95.49,215.94c0,0 92.6,22.6 174.6,-158.44c0,0 55,-102.61 135.48,-90.48l-138.14,-125.09c0,0 -71.3,-26 -147.1,93.14c-0.01,0 -36.99,77.25 -120.33,64.93Z",
    style: {
      fill: "#708bc4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.41,135.54l4.64,12.94l-8.93,8.87l10.41,-1.28l3.89,11.84l3.08,-13.44l9.69,-0.78l-8.59,-6.97l1.99,-12.68l-7.59,8.48l-8.59,-6.98Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,96.78l4.13,12.21l-7.81,9.71l9.29,-2.13l4.98,11.09l1.24,-13.77l10.16,-1.65l-8.81,-5.74l1.88,-12.07l-6.25,8.09l-8.81,-5.74Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.32,73.19l4.47,10.36l-7.67,10.69l9.16,-3.1l4.47,10.36l2.97,-12.82l10.53,-1.9l-9.8,-5.61l3.34,-13.07l-8.18,9.96l-9.29,-4.87Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.21,72.5l4.48,10.36l-9.3,9.13l10.64,-2.52l4.11,10.61l3.34,-13.07l10.78,-1.53l-8.79,-4.15l3.08,-13.44l-9.04,9.49l-9.3,-4.88Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.56,91.8l4.47,10.36l-9.29,9.13l10.64,-2.52l4.11,10.61l3.33,-13.07l10.78,-1.53l-8.79,-4.15l3.09,-13.44l-9.05,9.49l-9.29,-4.88Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.19,121.51l4.47,10.36l-9.29,9.13l10.63,-2.52l4.12,10.61l3.33,-13.07l10.78,-1.53l-8.79,-4.15l3.09,-13.44l-9.05,9.49l-9.29,-4.88Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.14,168.91l4.98,11.09l-8.85,13.66l10.72,-4.73l4.59,9.74l2.22,-13.91l11.34,-4.62l-10.02,-4.37l2.1,-13.29l-6.83,9.57l-10.25,-3.14Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.08,213.39l3.89,11.84l-7.76,12.9l10.36,-4.47l4.36,10.98l2.08,-14.9l9.74,-4.58l-8.79,-4.15l2.33,-14.53l-7.31,10.44l-8.9,-3.53Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.36,240.56l4.02,12.82l-9.38,11.34l9.29,-2.13l4.12,10.62l3.08,-13.44l9.63,-3.97l-7.58,-5.52l2.08,-14.89l-7.06,10.8l-8.2,-5.63Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.64,245.28l3.66,13.07l-9.81,8.4l9.94,-0.42l2.88,10.39l3.84,-12.35l10.89,-2.15l-7.97,-6.86l1.88,-12.07l-7.11,7.62l-8.2,-5.63Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.86,221.58l3.78,12.46l-12.02,8.31l12.66,0.4l2.43,12.85l4.79,-14.08l11.9,-0.7l-8.95,-6.72l3.78,-15.54l-10.64,9.52l-7.73,-6.5Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,178.8l3.78,12.46l-12.02,8.31l12.66,0.39l2.43,12.86l4.79,-14.09l11.9,-0.69l-8.96,-6.72l3.79,-15.54l-10.64,9.51l-7.73,-6.49Z",
    style: {
      fill: "#ffd746",
      fillRule: "nonzero"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.96,170.81l-22,-24.47c-1.414,-1.574 -3.836,-1.704 -5.41,-0.29l-1.77,1.62l-9.2,-10.25c-3.598,-4.007 -9.763,-4.338 -13.77,-0.74l-12,10.77c-4.007,3.598 -4.339,9.764 -0.74,13.77l9.2,10.25l-1.79,1.61c-1.574,1.414 -1.704,3.837 -0.29,5.41l22,24.47c1.414,1.575 3.836,1.705 5.41,0.29l30.08,-27c0.764,-0.681 1.223,-1.639 1.276,-2.661c0.052,-1.022 -0.306,-2.023 -0.996,-2.779Zm-60.61,-10.14c-3.599,-4.006 -3.267,-10.172 0.74,-13.77l6.75,-6.06c4.007,-3.598 10.172,-3.267 13.77,0.74l7.55,8.41l-21.26,19.08l-7.55,-8.4Zm34.08,13.86l3.56,4c0.793,0.881 0.721,2.238 -0.16,3.03c-0.881,0.793 -2.237,0.721 -3.03,-0.16l-3.76,-4.19c-2.379,0.575 -4.837,-0.588 -5.902,-2.792c-1.066,-2.203 -0.449,-4.852 1.479,-6.359c1.928,-1.508 4.647,-1.466 6.529,0.1c1.881,1.565 2.416,4.231 1.284,6.401l0,-0.03Z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 0,
    y: 0,
    width: "155px",
    height: "201px",
    transform: "matrix(0.821606,-0.568271,-0.571019,-0.82558,193.636,208.105)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M179.59,138.12l-11.39,10.23c-3.806,3.418 -4.12,9.276 -0.7,13.08l9.65,10.75l2.49,-2.24l-8.08,-9c-3.42,-3.804 -3.106,-9.662 0.7,-13.08l6.41,-5.75c3.805,-3.42 9.662,-3.106 13.08,0.7l8.08,9l2.49,-2.24l-9.65,-10.75c-3.418,-3.806 -9.275,-4.12 -13.08,-0.7Z",
    style: {
      fill: "#f3f7fb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.1,147.04l-28.57,25.63c-1.497,1.342 -1.622,3.644 -0.28,5.14l20.87,23.24c1.342,1.497 3.643,1.622 5.14,0.28l28.58,-25.66c1.497,-1.342 1.622,-3.643 0.28,-5.14l-20.84,-23.21c-0.646,-0.73 -1.558,-1.172 -2.531,-1.224c-0.974,-0.053 -1.928,0.287 -2.649,0.944Zm0.81,27.05l3.38,3.77c0.751,0.829 0.688,2.109 -0.14,2.86c-0.828,0.751 -2.109,0.689 -2.86,-0.14l-3.57,-4c-2.261,0.544 -4.596,-0.563 -5.606,-2.658c-1.01,-2.095 -0.421,-4.611 1.413,-6.041c1.835,-1.43 4.418,-1.386 6.203,0.104c1.786,1.491 2.29,4.025 1.21,6.085l-0.03,0.02Z",
    style: {
      fill: "#f3f7fb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,150.05l192.01,438.55l14.53,-4.67l-192.14,-439.53l-14.4,5.65Z",
    style: {
      fill: "#f3f7fb",
      fillRule: "nonzero"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "52px",
    height: "67px",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdImgPrivacy);
export default __webpack_public_path__ + "static/media/fd_img_privacy.8143b2fc.svg";
export { ForwardRef as ReactComponent };